/* eslint-disable import/prefer-default-export */
import graphqlClient from '../graphql';
import { generateInvoiceReportGql } from './gql';

export const generateInvoiceReportApi = (input) => {
  return graphqlClient.request(generateInvoiceReportGql, { input });
};
